import { useTranslation } from 'react-i18next'

import { TableCellInfo } from '../../TableCellInfo'
import { TableCellNumber } from '../../TableCellNumber'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import * as styles from './TableFlatCell.module.css'

function TableFlatCell({
  done,
  notCreatedTooltip = 'Table.NotCreatedFlatTooltipKey',
  unread,
  value,
  valuePrefix = 'Flat.FlatNumberKey',
  ...cellProps
}) {
  const { t } = useTranslation()

  return value ? (
    <TableCellBase {...cellProps}>
      <TableCellNumber
        done={done}
        unread={unread}
        value={value.number}
        valuePrefix={valuePrefix}
      />
      {Number.isFinite(value.id) ? null : (
        <TableCellInfo className={styles.info} value={t(notCreatedTooltip)} />
      )}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableFlatCell
